import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notification_list } from '../../Apis';


export const GetNotifictaions = createAsyncThunk('GetNotifictaions', async ({ token, page }, { rejectWithValue }) => {
    try {
        const response = await notification_list(token, page);
        return response.data; // ✅ just the JSON

    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const notificationSlice = createSlice({
    name: 'noti',
    initialState: {
        error: null,
        success: false,
        data: []

    },
    reducers: {
        clearNotiStatus: state => {
            state.success = false;
            state.error = null;
        },
        addNotification: (state, action) => {
            // console.log("show add notification from ---->", state.data.data);
            // console.log("show add notification from ---->", action.payload);

            const NewNotify = action.payload;
            // console.log("show add new notify from ---->", action.payload);
            state.data.data = [NewNotify, ...(state.data.data || [])]
        }
    },
    extraReducers: builder => {
        builder
            // gett
            .addCase(GetNotifictaions.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetNotifictaions.fulfilled, (state, action) => {
                state.error = null;
                state.success = true;

                const { current_page, last_page, data: notiData } = action.payload.data;

                if (current_page > 1) {
                    // append for infinite scroll
                    state.data = {
                        ...state.data,
                        current_page,
                        last_page,
                        data: [...state.data.data, ...notiData],
                    };
                } else {
                    // first page → replace
                    state.data = action.payload.data;
                }
            })

            .addCase(GetNotifictaions.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearNotiStatus, addNotification } = notificationSlice.actions;
export default notificationSlice.reducer;

